module.exports = __webpack_public_path__ + "static/media/20x102.daa53a5c.png";